<script>
	import UILink from "./UILink.svelte";

	export let data = {};
</script>

<section class="UIAboutRoundFrame _{data.style}">
	<div class="UIAboutRoundFrame-text">
		{@html data.text.split("\n").join("<br>")}
	</div>
	{#if data.url}
		<div class="UIAboutRoundFrame-link">
			<UILink
				data={{
					style: "text",
					target: "url",
					url: data.url,
					label: data.linkLabel,
				}}
			/>
		</div>
	{/if}
</section>

<style global>
	.UIAboutRoundFrame {
		margin: 0 auto;
		text-align: center;
		padding: 1.5em 1em;
		border-radius: 2em;
	}
	.UIAboutRoundFrame._red {
		max-width: 1280px;
		border: 2px solid #bb5858;
	}
	.UIAboutRoundFrame._gray {
		max-width: 760px;
		border: 2px solid #61788c;
	}

	:global(.pc) .UIAboutRoundFrame {
		border-radius: 12em;
		padding: 3em;
	}

	:global(.sp) .UIAboutRoundFrame-text {
		font-size: 1.1em;
	}
	:global(.pc) .UIAboutRoundFrame-text {
		font-size: 1.25em;
	}

	.UIAboutRoundFrame-link {
		margin: 1.5em 0 -1em;
		font-size: 1.1em;
		text-align: center;
	}
	.UIAboutRoundFrame-link > * {
		display: inline-block;
	}
</style>
